/** Must stay aligned with backend `setpilot.upload.*` defaults. */
export const MAX_UPLOAD_FILE_MB = 50;
export const MAX_UPLOAD_FILE_BYTES = MAX_UPLOAD_FILE_MB * 1024 * 1024;
export const MAX_TRACKS_PER_SESSION = 50;
